import { newCache, productQtyVar, selectedStore } from './cache';
import { setDevice } from './local/device';
import { setCookies } from './local/cookies';
import { setHeaders } from './local/headers';
import { setConfig } from './local/config';
import { setOneDayDeliveryFiltered } from './local/one-day-delivery';

export const getCache = req => {
  const cache = newCache();

  setDevice(cache, req);
  setConfig(cache);
  setHeaders(cache, req);
  setCookies(cache, req);
  setOneDayDeliveryFiltered(cache, req);

  return cache;
};

export { productQtyVar, selectedStore };
